import React from "react"
import { DialogTitle, Grid, IconButton } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import PropTypes from "prop-types"

/**
 * A dialog title component with a close button at the end (right for LTR locales)
 * @param children - The dialog title content
 * @param onClose - Handler on close button click
 * @param rest - DialogTitle props
 * @returns {JSX.Element}
 * @constructor
 */
export default function DialogTitleWithClose({ children, onClose, ...rest }) {
  return (
    <DialogTitle {...rest}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        wrap="nowrap"
      >
        <Grid item xs>
          {children}
        </Grid>
        <Grid item>
          <IconButton onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
    </DialogTitle>
  )
}

DialogTitleWithClose.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  onClose: PropTypes.func.isRequired
}
